// Position in an array reflects a chart number, One, Two, Three or Four.
export const config = {
  dataOneKey: {
    Load: 'load_profile_kWh' as const,
    PV: 'pv_production_kWh' as const,
    Storage: 'soc_history_%' as const,
    FiniteDieselGenerator: 'production_kWh' as const,
    MarketMaker: undefined,
    InfiniteBus: undefined,
  },
  dataTwoKey: {
    Load: 'trade_energy_kWh' as const,
    PV: 'trade_energy_kWh' as const,
    Storage: 'trade_energy_kWh' as const,
    FiniteDieselGenerator: 'sold_trade_energy_kWh' as const,
    MarketMaker: 'sold_trade_energy_kWh' as const,
    InfiniteBus: 'sold_trade_energy_kWh' as const,
  },
  YAxis: {
    Load: {
      label: ['Load Profile', 'Energy Bought', 'Energy Price'],
    },
    PV: {
      label: ['PV Profile', 'Energy Sold', 'Energy Price'],
    },
    Storage: {
      label: ['State of Charge', 'Energy Traded', 'Energy Price'],
    },
    CommercialProducer: {
      label: [null, 'Energy Sold', 'Energy Price'],
    },
    FiniteDieselGenerator: {
      label: ['Energy Profile', 'Energy Sold', 'Energy Price'],
    },
    MarketMaker: {
      label: [null, 'Energy Sold', 'Energy Price', 'Energy Bought'],
    },
    InfiniteBus: {
      label: [null, 'Energy Sold', 'Energy Price', 'Energy Bought'],
    },
  },
  tooltipLabels: {
    Load: ['Load Profile', 'Energy Bought', 'Load Profile'],
    PV: ['PV Profile', 'Energy Sold', 'PV Profile'],
    Storage: ['State of Charge', 'Energy Traded'],
    CommercialProducer: ['', 'Energy Sold'],
    FiniteDieselGenerator: ['Energy Profile', 'Energy Sold', 'Energy Profile'],
    MarketMaker: ['', 'Energy Sold', '', 'Energy Bought'],
    InfiniteBus: ['', 'Energy Sold', '', 'Energy Bought'],
  },
  tooltipUnits: {
    Load: ['kWh', 'kWh', 'kWh'],
    PV: ['kWh', 'kWh', 'kWh'],
    Storage: ['%', 'kWh'],
    CommercialProducer: ['', 'kWh'],
    FiniteDieselGenerator: ['kWh', 'kWh', 'kWh'],
    MarketMaker: ['', 'kWh', '', 'kWh'],
    InfiniteBus: ['', 'kWh', '', 'kWh'],
  },
};
